import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { ActionResponse } from 'types/ActivationOrderTypes';

export type fundActivationOrderDataType = {
  id: string;
  body: {
    tx_date: string;
    amount: {
      currency: string;
      value: number;
    };
    factor_bank_account_id: number;
    recipient_company_id?: string;
  };
  successCallback?: (result: ActionResponse) => void;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  body,
  successCallback,
  errorCallback,
  resultKey = 'fundActivationOrderData',
}: fundActivationOrderDataType) =>
  requestAsync({
    url: endpoints.getAOActionFundUrl(id),
    transform: (response: ActionResponse) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getAOActionFundUrl(id)}`,
    body,
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
